export type TemplatesTab = 'declaration' | 'product' | 'item-field';

const TEMPLATES_TABS: TemplatesTab[] = ['declaration', 'product', 'item-field'];

export const isTemplatesTab = (value: string | null): value is TemplatesTab =>
    TEMPLATES_TABS.includes(value as TemplatesTab);
